<template>
  <b-modal ref="driver-card-modal" @ok="driverCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.drivers.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-tabs>
        <MainTab
          v-bind:driver="driver"
          v-bind:vehicles="vehicles"
          v-bind:companies="companies"
          ref="main-tab"
        ></MainTab>
        <LimitsTab
          v-bind:driver="driver"
          ref="limits-tab"
        ></LimitsTab>
      </b-tabs>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import MainTab from "./MainTab.vue";
import LimitsTab from "./LimitsTab.vue";
import { driverService } from "../../../services";

export default {
  name: "UpdateDriverPage",
  components: {
    MainTab,
    LimitsTab
  },
  data() {
    return {
      driver: null,
      companies: [],
      vehicles: []
    };
  },
  methods: {
    open(driver, companies, vehicles) {
      this.driver = driver;
      this.companies = companies;
      this.vehicles = vehicles;

      this.$refs["driver-card-modal"].show();
    },
    async driverCardModalOk(event) {
      if (!this.$refs["main-tab"].validate()) {
        event.preventDefault();
        return;
      }
      
      const driverCard = {
        id: this.driver.id,
        firstName: this.driver.firstName,
        lastName: this.driver.lastName,
        patronymic: this.driver.patronymic,
        birthDate: this.driver.birthDate
          ? (this.driver.birthDate.getTime() / 1000).toString()
          : null,
        rfid: this.driver.rfid,
        gender: this.driver.gender,
        phoneNumber: this.driver.phoneNumber,
        description: this.driver.description,
        vehicleId: this.driver.vehicleId ? this.driver.vehicleId.toString() : null,
        companyId: parseInt(this.driver.companyId),
      };

      const updateDriverResponse = await driverService.updateDriver(driverCard);

      if (
        updateDriverResponse.isSuccess &&
        updateDriverResponse.data &&
        updateDriverResponse.data.countUpdatedRows == 1
      ) {
        this.$emit("driverUpdatedSuccessEvent", driverCard);
      } else {
        this.$emit("driverUpdatedFailEvent");
      }
    },
  },
};
</script>
